import React from 'react';
import BuyGridAccordion from '../../../components/BuyGridAccordion/BuyGridAccordion';
import GarmentMeasurement from '../../GarmentMeasurements/GarmentMeasurement';

export default function MeasurementsAccordion({
  onClick, activeAccordion, tmntData, isEyewearProduct, activeProduct,
}) {
  const accordionIdentifier = 'product-measurements__accordion';
  const garmentMeasurements = activeProduct?.garmentMeasurements || [];

  const {
    eyewearDimensionLensWidth,
    eyewearDimensionBridgeWidth,
    eyewearDimensionArmLength,
  } = garmentMeasurements;

  if (
    !isEyewearProduct
    || !eyewearDimensionLensWidth
    || !eyewearDimensionBridgeWidth
    || !eyewearDimensionArmLength
  ) return null;

  return (
    <BuyGridAccordion
      id="measurements"
      headerText={tmntData.measurementsAccordionTitle?.value}
      onClick={onClick(accordionIdentifier)}
      expanded={activeAccordion === accordionIdentifier}
    >
      <GarmentMeasurement
        measurementSize={`${eyewearDimensionLensWidth}mm`}
        measurementText={tmntData?.measurementsAccordionLensWidthLabel?.value}
        tooltipHeader={tmntData?.measurementsAccordionLendWidthTootipHeader?.value}
        tooltipText={tmntData?.measurementsAccordionLensWidthTooltipText?.value}
      />
      <GarmentMeasurement
        measurementSize={`${eyewearDimensionBridgeWidth}mm`}
        measurementText={tmntData?.measurementsAccordionBridgeWidthLabel?.value}
        tooltipHeader={tmntData?.measurementsAccordionBridgeWidthTooltipHeader?.value}
        tooltipText={tmntData?.measurementsAccordionBridgeWidthTooltipText?.value}
      />
      <GarmentMeasurement
        measurementSize={`${eyewearDimensionArmLength}mm`}
        measurementText={tmntData?.measurementsAccordionTempleLengthLabel?.value}
        tooltipHeader={tmntData?.measurementsAccordionTempleLengthTooltipHeader?.value}
        tooltipText={tmntData?.measurementsAccordionTempleLengthTooltipText?.value}
      />
    </BuyGridAccordion>
  );
}
